import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./components/crm/Sidebar";
import Topbar from "./components/crm/Topbar";
import { ShellContext } from "./context/ShellContext";
import { Toaster } from "react-hot-toast";
import { useAuth } from "./context/AuthContext";
import JuridentFeatures from './pages/JuridentFeatures';
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";
import "./styles/lightMode.css";
import "./components/crm/crm.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ========== LANDING PAGE COMPONENTS ==========
import LandingNavbar from "./landing/components/Navbar";
import LandingFooter from "./landing/components/Footer";
import AboutUs from './landing/components/AboutUs';
import AiDrafting from "./landing/components/AIDrafting";
import BookADemo from "./landing/components/BookADemo";
import AllTestimonials from "./landing/components/AllTestimonials";
import LandingHome from "./landing/components/Home";
import NewUILanding from "./landing/newui/NewUILanding";

// ========== PORTAL COMPONENTS ==========
import Hero from "./components/Hero";

// ========== AUTH PAGES ==========
import LawyerSignIn from "./pages/auth/lawyers/LawyerSignIn";
import LawyerSignUp from "./pages/auth/lawyers/LawyerSignUp";
import ClientSignIn from "./pages/auth/client/ClientSignIn";
import ClientSignUp from "./pages/auth/client/ClientSignUp";
import DepartmentSignIn from "./pages/auth/department/DepartmentSignIn";
import DepartmentSignUp from "./pages/auth/department/DepartmentSignUp";

// ========== PORTAL PAGES ==========
import ReraCaseList from "./pages/ReraFetchCases/ReraCaseList";
import Dashboard from "./pages/Dashboard";    
import Onboarding from "./pages/Onboarding";
import News from "./pages/News";
import TaskOverview from "./pages/TaskOverview";
import PendingCases from "./pages/PendingCases";
import DisposedCases from "./pages/DisposedCases";
import TodayCases from "./pages/TodayCases";
import AllCases from "./pages/AllCases";
import AddCase from "./pages/AddCase";
import ImportCases from "./pages/ImportCases";
import Drafts from "./pages/Drafts";
import CaseDetails from "./pages/CaseDetails";
import CaseNotes from "./pages/CaseNotes";
import EditCaseNotes from "./pages/EditCaseNotes";
import AddCaseNotes from "./pages/AddCaseNotes";
import EditCaseDetails from "./pages/EditCaseDetails";
import SavePopup from "./pages/SavePopup";
import BareAct from "./pages/bareAct";
import JuriAssistance from "./pages/JuriAssistance";
import SharedCases from "./pages/SharedCases";
import MyFiles from "./pages/MyFiles";
import MyClients from "./pages/MyClients";
import ClientDetails from "./pages/ClientDetails";
import CreateInvoice from "./pages/CreateInvoice";
import AllExpenses from "./pages/AllExpenses";
import Invoices from "./pages/Invoices";
import Bookmarks from "./pages/Bookmarks";
import Account from "./pages/Account";
import EmailVerification from "./pages/EmailVerification";
import ForgotPassword from "./pages/ForgotPassword";
import PhoneVerification from "./pages/PhoneVerification";
import TasksBoard from "./pages/tasks/TasksBoard";
import AddTask from "./pages/tasks/AddTask";
import TaskDetail from "./pages/tasks/TaskDetail";
import FindCases from "./pages/HighCourtFetchCases/FindCases";
import FindCaseOptions from "./pages/FindCasesOptions";
import FetchFromDistrictCourt from "./pages/DistrictCourtFetchCases/FetchFromDistrictCourt";
import DistrictCourtListScreen from "./pages/DistrictCourtFetchCases/DistrictCourtListScreen";
import DistrictCourtOrdersListScreen from "./pages/DistrictCourtFetchCases/DistrictCourtOrdersListScreen";
import DistrictCourtCaseDetails from "./pages/DistrictCourtFetchCases/DistrictCourtCaseDetails";
import ReraCaseSearch from "./pages/ReraFetchCases/ReraCaseSearch";
import CaseList from "./pages/ReraFetchCases/ReraCaseList";
import CaseFiles from "./pages/CaseFiles";
import GoogleCalendarSync from "./pages/GoogleCalendarSync";
import CaseListScreen from "./pages/HighCourtFetchCases/CaseListScreen";
import CaseDetailsScreen from "./pages/HighCourtFetchCases/FetchCaseDetailsScreen";
import CourtOrdersListScreen from "./pages/HighCourtFetchCases/CourtOrdersListScreen";
import ManageTeamsPage from "./pages/ManageTeams/ManageTeamsPage";
import TeamOverviewPage from "./pages/ManageTeams/TeamOverviewPage";
import ClientHome from "./pages/clientpages/Home";
import SearchLawyer from "./pages/clientpages/SearchLawyer";
import CaseModal from "./pages/AddMetric";
import EditCaseModal from "./pages/EditMetic";
import MetricCases from "./pages/MetricCases";
import DatewiseCases from "./pages/DatewiseCases";
import FilesSection from "./pages/FilesSection";
import ActPage from "./pages/ActPage";
import ActNotes from "./pages/ActNotes";
import NcltCases from "./pages/NcltFetchCases/NcltCases";
import NcltCaseDetails from "./pages/NcltFetchCases/NcltCaseDetails";
import ExportCauseList from "./pages/ExportCauseList";
import NcltCaseFullDetails from "./pages/NcltFetchCases/NcltCaseFullDetails";
import SupremeCourtSearch from "./pages/SupremeCourtFetchCases/SupremeCourtSearch";
import SupremeCourtResults from "./pages/SupremeCourtFetchCases/SupremeCourtResults";
import SupremeCourtCauseListResults from "./pages/SupremeCourtFetchCases/SupremeCourtCauseListResults";
import NGTSearch from "./pages/NGTFetchCases/NGTSearch";
import ESCRSearch from "./pages/ESCRFetchCases/ESCRSearch";
import ESCRJudgmentList from "./pages/ESCRFetchCases/ESCRJudgmentList";
import ESCRJudgmentView from "./pages/ESCRFetchCases/ESCRJudgmentView";
import EJagritiSearch from "./pages/EJagritiFetchCases/EJagritiSearch";
import EJagritiResults from "./pages/EJagritiFetchCases/EJagritiResults";
import EJagritiCaseDetail from "./pages/EJagritiFetchCases/EJagritiCaseDetail";
import NGTCaseList from "./pages/NGTFetchCases/NGTCaseList";
import NGTCaseDetails from "./pages/NGTFetchCases/NGTCaseDetails";
import NGTJudgementList from "./pages/NGTFetchCases/NGTJudgementList";
import NGTJudgementDetails from "./pages/NGTFetchCases/NGTJudgementDetails";

// ========== STATIC PAGES ==========
import Faq from "./pages/staticPages/Faq";
import Terms from "./pages/staticPages/Terms";
import Refunds from "./pages/Refunds";
import Feedback from "./pages/staticPages/Feedback";
import Contactus from "./pages/staticPages/Contactus";
import ContactSupport from "./pages/ContactSupport";
import Aboutus from "./pages/staticPages/Aboutus";
import Contact from "./pages/staticPages/Contact";
import About from "./pages/staticPages/About";
import { Analytics } from "@vercel/analytics/react"
import Subscription from "./pages/Subscription";
import PaymentRedirect from "./pages/PaymentRedirect";
import AdminFunctions from "./pages/AdminFunctions";
import InternshipForm from "./pages/InternshipForm";
import StudentUpdates from "./pages/StudentUpdates";
import Referrals from "./pages/Referrals";
import ReraCaseDetails from "./pages/ReraFetchCases/ReraCaseDetails";
import UpReraComplaintDetail from "./pages/ReraFetchCases/UpReraComplaintDetail";
import Subsplan from "./pages/staticPages/subsplans";
import Advocate from "./landing/components/Advocate";
import Enterprise from "./landing/components/Enterprise";
import ClientPage from "./landing/components/ClientPage";
import StudentPage from "./landing/components/StudentPage";
import LawyerPage from "./landing/components/LawyerPage";
import Career from "./landing/careers/Careers";
// ========== LAYOUT COMPONENTS ==========

// Landing Page Layout
function LandingLayout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useEffect(() => {
  if (location.hash === "#help") {
    setTimeout(() => {
      const section = document.getElementById("help");
      section?.scrollIntoView({ behavior: "smooth" });
    }, 150);
  }
}, [location]);

  return (
    <div className="bg-white scroll-smooth min-h-screen flex flex-col">
      <LandingNavbar />
      <div className="flex-1">
        <Outlet />
      </div>
      {isHomePage && <LandingFooter />}
    </div>
  );
}

// Portal Layout
function PortalLayout() {
  const { globalUser } = useAuth();

  // FCM foreground notifications are handled by the single listener in
  // src/services/fcmService.js (registered via registerFcmToken on login).
  // No additional onMessage listener needed here — adding one causes duplicates.

  useEffect(() => {
    // Service Worker Registration
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`, { updateViaCache: "none" })
        .then((registration) => {
          // Force immediate update check so new SW takes over
          registration.update();
          console.log("Service Worker registered:", registration);
        })
        .catch((err) => {
          console.log("Service Worker registration failed:", err);
        });
    }
  }, []);

  return (
    <div>
      <Toaster
        position="top-center"
        containerStyle={{ zIndex: 9999 }}
        toastOptions={{ style: { marginTop: "4rem" } }}
      />
      
        <Outlet />
      
    </div>
  );
}

// Persistent CRM shell: fixed sidebar on the left, the active page scrolls
// in the content area on the right. Wraps the protected portal routes so the
// sidebar stays put while navigating instead of each page opening standalone.
function PortalShell() {
  const { pathname } = useLocation();
  // Below the desktop breakpoint the sidebar becomes an off-canvas drawer
  // (see sidebar.css) toggled from the topbar's hamburger. On desktop the
  // sidebar is always visible and this flag is inert.
  const [navOpen, setNavOpen] = useState(false);

  // The portal runs in the light CRM theme. The old per-page dark/light toggle
  // lived in the legacy navbar, which is suppressed inside the shell, so pin the
  // body to light-mode here.
  useEffect(() => {
    document.body.classList.add("light-mode");
    document.body.classList.remove("dark-mode");
    localStorage.setItem("theme", "light");
  }, []);

  // Navigating away should always dismiss the mobile drawer.
  useEffect(() => {
    setNavOpen(false);
  }, [pathname]);

  return (
    <ShellContext.Provider value={true}>
      <div className="crm-shell">
        <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
        <div className="crm-shell-main">
          <Topbar onMenuClick={() => setNavOpen((v) => !v)} />
          <main style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
            <Outlet />
          </main>
        </div>
      </div>
    </ShellContext.Provider>
  );
}

// Portal Home Component -
function PortalHome() {
  const { globalUser } = useAuth();
  return globalUser ? <Navigate to="/portal/dashboard" replace /> : <Hero />;
}

// Scroll to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
// ========== MAIN APP COMPONENT =======
function App() {
  return (
    <>
    <Router basename={process.env.PUBLIC_URL}>
      <ScrollToTop />
       <Analytics />
      <Routes>
        {/* ========== LANDING PAGE ROUTES ========== */}
<Route path="/" element={<LandingLayout />}>
  <Route index element={<LandingHome />} />
  <Route path="aboutus" element={<AboutUs />} />
  <Route path="aiDrafting" element={<AiDrafting />} />
  <Route path="demo" element={<BookADemo />} />
  <Route path="testimonials" element={<AllTestimonials />} />
  <Route path="advocate" element={<Advocate />} />
  <Route path="enterprise" element={<Enterprise />} />
  <Route path="careers" element={<Career />} />
  <Route path="client" element={<ClientPage />} />
  <Route path="student" element={<StudentPage />} />
  <Route path="lawyer" element={<LawyerPage />} />
  <Route path="/subPlans" element={<Subsplan />} />

  {/* Add Jurident features page here */}
  <Route path="jurident/app" element={<JuridentFeatures />} />
</Route>


        {/* ========== NEW UI LANDING (standalone - has its own navbar) ========== */}
        <Route path="/new-ui" element={<NewUILanding />} />


        {/* ========== PORTAL ROUTES ========== */}
        <Route path="/portal" element={<PortalLayout />}>
          {/* Portal Home */}
          <Route index element={<PortalHome />} />

          {/* ===== PUBLIC AUTH ROUTES ===== */}
          <Route path="onboarding" element={<Onboarding />} />
          <Route path="LawyerSignIn" element={<LawyerSignIn />} />
          <Route path="LawyerSignUp" element={<LawyerSignUp />} />
          <Route path="ClientSignIn" element={<ClientSignIn />} />
          <Route path="ClientSignUp" element={<ClientSignUp />} />
          <Route path="DepartmentSignIn" element={<DepartmentSignIn />} />
          <Route path="DepartmentSignUp" element={<DepartmentSignUp />} />
          <Route path="ForgotPassword" element={<ForgotPassword />} />
          <Route path="EmailVerification" element={<EmailVerification />} />
          <Route path="phoneVerification" element={<PhoneVerification />} />
          <Route path="payment-redirect" element={<PaymentRedirect />} />
          <Route path="/portal/case-files/:id" element={<CaseFiles />} />

          

          {/* ===== PROTECTED PORTAL ROUTES ===== */}
          <Route element={<ProtectedRoute />}>
           <Route element={<PortalShell />}>
            <Route path="Dashboard" element={<Dashboard />} />
            <Route path="PendingCases/:status" element={<PendingCases />} />
            <Route path="DisposedCases/:status" element={<DisposedCases />} />
            <Route path="AllCases" element={<AllCases />} />
            <Route path="todaycases" element={<TodayCases />} />
            <Route path="AddCase" element={<AddCase />} />
            <Route path="ImportCases" element={<ImportCases />} />
            <Route path="Drafts" element={<Drafts />} />
            <Route path="export-cause-list" element={<ExportCauseList />} />
            <Route path="case/:id" element={<CaseDetails />} />
            <Route path="client/:id" element={<ClientDetails />} />
            <Route path="case-notes" element={<CaseNotes />} />
            <Route path="editcase-notes" element={<EditCaseNotes />} />
            <Route path="addcase-notes" element={<AddCaseNotes />} />
            <Route path="case/:id/edit" element={<EditCaseDetails />} />
            <Route path="SavePopup" element={<SavePopup />} />
            <Route path="calendar" element={<TaskOverview />} />
            <Route path="news" element={<News />} />
            <Route path="about" element={<About />} />
            <Route path="filesSection/:id" element={<FilesSection />} />
            <Route path="actPage/:url" element={<ActPage />} />
            <Route path="actNotes/:url" element={<ActNotes />} />
            <Route path="bareAct" element={<BareAct />} />
            <Route path="contact" element={<Contact />} />
            <Route path="account" element={<Account />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="tasks" element={<TaskOverview />} />
            
            <Route path="JuriAssistance" element={<JuriAssistance />} />
            <Route path="SharedCases" element={<SharedCases />} />
            <Route path="MyFiles" element={<MyFiles />} />
            <Route path="MyClients" element={<MyClients />} />
            <Route path="expenses" element={<AllExpenses />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="create-invoice" element={<CreateInvoice />} />
            <Route path="invoice/:id" element={<CreateInvoice />} />
            <Route path="Bookmarks" element={<Bookmarks />} />
            <Route path="teams" element={<TeamOverviewPage />} />
            <Route path="manage-teams" element={<ManageTeamsPage />} />
            <Route path="manage-teams/:teamId" element={<ManageTeamsPage />} />
            <Route path="tasksevents" element={<TasksBoard />} />
            <Route path="add-task" element={<AddTask />} />
            <Route path="task/:id" element={<TaskDetail />} />
            <Route path="findCasesOptions" element={<FindCaseOptions />} />
            <Route path="fetchfromhighcourt" element={<FindCases />} />
            <Route path="addMetric" element={<CaseModal />} />
            <Route path="editMetric/:id" element={<EditCaseModal />} />
            <Route path="metric/:id" element={<MetricCases />} />
            <Route path="datewise/:id" element={<DatewiseCases />} />
            <Route path="fetchfromdistrictcourt" element={<FetchFromDistrictCourt />} />
            <Route path="case/:id/case-files" element={<CaseFiles />} />
            <Route path="googlecalendar" element={<GoogleCalendarSync />} />
            <Route path="caseList" element={<CaseListScreen />} />
            <Route path="courtOrders" element={<CourtOrdersListScreen />} />
            <Route path="caseDetails" element={<CaseDetailsScreen />} />
            <Route path="clientHome" element={<ClientHome />} />
            <Route path="searchLawyer" element={<SearchLawyer />} />
            <Route path="districtCourtList" element={<DistrictCourtListScreen />} />
            <Route path="districtCourtOrders" element={<DistrictCourtOrdersListScreen />} />
            <Route path="districtCourtCaseDetails" element={<DistrictCourtCaseDetails />} />
            <Route path="fetchfromrera" element={<ReraCaseSearch />} />
            <Route path="rera/caseList" element={<ReraCaseList />} />
            <Route path="rera/upComplaintDetail" element={<UpReraComplaintDetail />} />
            <Route
  path="/portal/rera/caseDetails/:filingNo"
  element={<ReraCaseDetails />}
/>


            <Route path="fetchfromsupremecourt" element={<SupremeCourtSearch />} />
            <Route path="supremeCourtResults" element={<SupremeCourtResults />} />
            <Route path="supremeCourtCauseListResults" element={<SupremeCourtCauseListResults />} />
            <Route path="fetchfromngt" element={<NGTSearch />} />
            <Route path="ngt/caseList" element={<NGTCaseList />} />
            <Route path="ngt/caseDetails" element={<NGTCaseDetails />} />
            <Route path="ngt/judgementList" element={<NGTJudgementList />} />
            <Route path="ngt/judgementDetails" element={<NGTJudgementDetails />} />
            <Route path="fetchfromnclt" element={<NcltCases />} />
            <Route path="fetchfromescr" element={<ESCRSearch />} />
            <Route path="escr/judgmentList" element={<ESCRJudgmentList />} />
            <Route path="escr/judgment" element={<ESCRJudgmentView />} />
            <Route path="fetchfromejagriti" element={<EJagritiSearch />} />
            <Route path="ejagriti/results" element={<EJagritiResults />} />
            <Route path="ejagriti/case" element={<EJagritiCaseDetail />} />
            <Route path="ncltCaseDetails" element={<NcltCaseDetails />} />
            <Route
  path="/portal/ncltCaseFullDetails"
  element={<NcltCaseFullDetails />}
/>

            <Route path="admin-functions" element={<AdminFunctions />} />
            <Route path="internship-form" element={<InternshipForm />} />
            <Route path="student-updates" element={<StudentUpdates />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="contact-us" element={<ContactSupport />} />
           </Route>
          </Route>

          {/* ===== PUBLIC PORTAL PAGES ===== */}
          <Route path="aboutus" element={<Aboutus />} />
          <Route path="contactus" element={<Contactus />} />
          <Route path="terms" element={<Terms />} />
          <Route path="refunds" element={<Refunds />} />
          <Route path="faq" element={<Faq />} />
          <Route path="feedback" element={<Feedback />} />
        </Route>

        {/* ========== 404 NOT FOUND ROUTE ========== */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
    </Router>
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
      />
    </>
  );
}

export default App;
